// Base pre-fetcher
import { AbstractDataPreFetcher } from "./AbstractDataPreFetcher";
/**
 * Data pre-fetcher that is used to prefetch data for Planner
 */
export class DataPreFetcher extends AbstractDataPreFetcher {
    /**
     * Constructor for DataPreFetcher
     * @param deeplinkRoute The deeplink route to prefetch data for if any
     * @param context The context of the current user
     * @param getAccessTokenFromHostAdaptor Function to get access token from the host adaptor
     */
    constructor(deeplinkRoute, context, getAccessTokenHostAdaptor) {
        super();
        this.deeplinkRoute = deeplinkRoute;
        this.context = context;
        this.getAccessTokenHostAdaptor = getAccessTokenHostAdaptor;
    }
    setupHostDependencies() {
        // No op. For non entry-point based data prefetcher, the pre-fetch process is triggered from the app bootstrap itself after all critical dependencies are set up.
        // Therefore, no additional setup is required in the Prefetcher.
        return Promise.resolve();
    }
    getInitialDeeplinkRoute() {
        return Promise.resolve(this.deeplinkRoute);
    }
    async getAccessToken(resource) {
        return await this.getAccessTokenHostAdaptor(resource);
    }
    async getUserId() {
        const userId = this.context.userId;
        if (!userId) {
            throw new Error("UserId is not available");
        }
        return Promise.resolve(userId);
    }
    canPreFetch() {
        return Promise.resolve(!this.context.isBackgroundLoad);
    }
}
